import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import IsDesktop from "theme/utils/isDesktop";
import Icon from "theme/components/atoms/Icon";

import Button from "theme/components/atoms/Button";
import { H5 } from "theme/components/atoms/Typography/Heading";

const TabView = ({ tabs }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  return (
    <IsDesktop>
      {(isDesktop) => {
        return isDesktop ? (
          <section className="tab-view">
            <div className="tab-view__list-wrapper">
              <ul className="tab-view__list">
                {tabs.map((tab, index) => (
                  <li
                    key={`tab-${index}`}
                    id={tab.id ?? ""}
                    className={classNames("tab-view__list__item", {
                      "tab-view__list__item--active": index === currentIndex,
                    })}
                    onClick={() => setCurrentIndex(index)}
                  >
                    <H5>{tab.title}</H5>
                  </li>
                ))}
              </ul>
            </div>
            <div className="tab-view__content">
              {tabs.map((tab, index) => (
                <div
                  key={`content-${index}`}
                  className={classNames("tab-view__content__item", {
                    "tab-view__content__item--active": index === currentIndex,
                  })}
                >
                  {tab.renderContent()}
                </div>
              ))}
            </div>
          </section>
        ) : (
          <section className="tab-view tab-view--mobile">
            <div className="tab-view__list-wrapper">
              {tabs.map((tab, index) => (
                <div key={`tab-${index}`} id={tab.id ?? ""}>
                  <Button
                    onClick={() => {
                      if (index === currentIndex) {
                        setCurrentIndex("");
                      } else {
                        setCurrentIndex(index);
                      }
                    }}
                    appearance="link"
                  >
                    <H5>{tab.title}</H5>
                    {currentIndex === index ? (
                      <Icon
                        key="icon-up"
                        icon="chevron-up"
                        size="tiny"
                        title="open"
                      />
                    ) : (
                      <Icon
                        key="icon-down"
                        icon="chevron-down"
                        size="tiny"
                        title="close"
                      />
                    )}
                  </Button>
                  {currentIndex === index && (
                    <div key={`content-${index}`}>{tab.renderContent()}</div>
                  )}
                </div>
              ))}
            </div>
          </section>
        );
      }}
    </IsDesktop>
  );
};

TabView.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      renderContent: PropTypes.func.isRequired,
    })
  ).isRequired,
};

export default TabView;
